import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ILabReportLabPartnerResponse } from "@/api_framework/api_modals/LabReport";
import { setLabPartnerList } from "@/app_redux/reducers/slices/auth/lab_report_slice";

AxiosCurlirize(axios, () => {});
export const useLabReportLabPartnerListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (lab_test_name?: string) => {
      let URL = null;
      if (lab_test_name) {
        URL = `${LAB_REPORT?.LAB_PARTNER_LIST?.baseURL}?lab_test_name=${lab_test_name}`;
      } else {
        URL = `${LAB_REPORT?.LAB_PARTNER_LIST?.baseURL}`;
      }
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(URL ?? "", {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ILabReportLabPartnerResponse>) => {
            if (res.data.status === true) {
              dispatch(setLabPartnerList({ data: res.data.data }));
            } else {
              dispatch(setLabPartnerList({ data: [] }));
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
